import PropTypes from "prop-types";
import React, { useState } from "react";
import { fetchPutDescriptionCollection } from "../../utils/apis";
import { Box, Flex, Modal, Text, useMantineTheme } from "@mantine/core";
import CustomButton from "../mantineCustomComponents/CustomButton";
import TipTapEditor from "./TipTapEditor";
import { useStylesCollectionWindow } from "../../utils/mantine/useStylesCollectionWindow";

const DescriptionCollectionWindow = ({
  collectionID,
  onDescription,
  openedModalDescription,
  onOpenedModalDescription,
  form,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // Description Create success
  const [descriptionCreateSuccess, setDescriptionCreateSuccess] =
    useState(false);

  // Use custom styles for the Collection Window
  const { classes: useStylesCollectionWindowClasses } =
    useStylesCollectionWindow();

  return (
    <Modal
      opened={openedModalDescription}
      onClose={() => {
        form.setFieldValue("collectionDescription", "");
        onOpenedModalDescription(false);
      }}
      centered
      size="30rem"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      className={useStylesCollectionWindowClasses.collectionWindow}
    >
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          // Take current description value from the form without triggering collectionName validation
          const { collectionDescription } = form.getValues();

          const isSuccess = await fetchPutDescriptionCollection(
            collectionID,
            collectionDescription,
            onOpenedModalDescription,
            onDescription,
            form,
            setDescriptionCreateSuccess,
          );

          // Clear description field only after successful update so it is not reused when creating a new collection
          if (isSuccess) {
            form.setFieldValue("collectionDescription", "");
          }
        }}
      >
        <Text className="text">
          Description (Optional) – this information does not get put on a
          blockchain. It is hosted by vBase and can be edited and deleted later.
        </Text>

        <TipTapEditor
          className="editor"
          placeholder="Description"
          popup={true}
          value={form.getValues().collectionDescription || ""}
          onChange={(value) =>
            form.setFieldValue("collectionDescription", value)
          }
          error={form.errors.collectionDescription || ""}
        />

        {descriptionCreateSuccess ? (
          <Box className="collection-created-text success">
            Description updated!
          </Box>
        ) : (
          ""
        )}
        <Flex
          justify={theme.flex.justify.center}
          gap={theme.flex.gap.large}
          mb={theme.margin.xl}
          mt={theme.margin.xl}
        >
          <CustomButton
            text="Save"
            componentClasses="buttonBlack modal-button-submit"
          ></CustomButton>
        </Flex>
      </form>
    </Modal>
  );
};

DescriptionCollectionWindow.propTypes = {
  collectionID: PropTypes.string,
  openedModalDescription: PropTypes.bool.isRequired,
  onDescription: PropTypes.func.isRequired,
  onOpenedModalDescription: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    customColors: PropTypes.shape({
      black: PropTypes.string.isRequired,
      white: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  form: PropTypes.shape({
    onSubmit: PropTypes.func.isRequired,
    key: PropTypes.func.isRequired,
    getInputProps: PropTypes.func.isRequired,
    getValues: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    errors: PropTypes.func.isRequired,
  }).isRequired,
};
export default DescriptionCollectionWindow;
